import { useTranslation } from "react-i18next";
import {
  getAiSupportedTasks,
  useCreateAiSupportedTasks,
  useGetAiSupportedTasks,
} from "@packages/api/madlenAPI";
import {
  AiSupportedTasksCreateRequestDtoCourseName,
  AiSupportedTasksResponseDto,
} from "@packages/api/madlenAPI.schemas";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import {
  AiSupportedTasksCreateModal,
  CreateModalProps,
} from "@features/tools/components/create-modal/modals";
import AiSupportedTasksCard from "@features/tools/components/ai-supported-tasks/AiSupportedTasksCard";

const CreateAiSupportedTasksView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <AiSupportedTasksCreateModal
      title={t("aiSupportedTasks.result.title")}
      backPath="/content/ai-supported-tasks"
      themeColor="teal"
      loadingTitle={t("aiSupportedTasks.result.loading.title")}
      errorTitle={t("aiSupportedTasks.result.error.title")}
      errorDescription={t("aiSupportedTasks.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: AiSupportedTasksResponseDto;
    isImageLoading?: boolean;
    onCreateAgain: () => void;
  }) => (
    <AiSupportedTasksCard
      tool={toolData}
      isImageLoading={isImageLoading}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="ai-supported-tasks"
      useCreateTool={useCreateAiSupportedTasks}
      useGetTool={useGetAiSupportedTasks}
      getTool={getAiSupportedTasks}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: AiSupportedTasksResponseDto) =>
        data?.researchProcessDescription
      }
    />
  );
};

export default CreateAiSupportedTasksView;
